import API from "../../utils/api";

export const getSentCompanyInvitations = async (queryParams) => {
  return await API("/company-invitations")
    .get("/", {
      params: queryParams,
    })
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const getIncomingCompanyInvitations = async (queryParams) => {
  return await API("/company-invitations")
    .get("/incoming", {
      params: queryParams,
    })
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const acceptCompanyInvitation = async (id) => {
  return await API("/company-invitations")
    .patch(`/${id}/accept`)
    .then((response) => response.data)
    .catch((error) => error.response);
};

export const createCompanyInvitation = async (data) => {
  return await API("/company-invitations")
    .post("/", data)
    .then((response) => response.data)
    .catch((error) => error.response);
};
